import React, { useState, useEffect, useRef } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import scoringService from "../../services/ScoringService";
import { CardType } from '../../models/enums/CardType';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UseFullPageLoaderHook from "./Hook/UseFullPageLoaderHook";
import { ScoringInputType } from '../../models/enums/ScoringInputType';
const DeletePlayerPopupModal = (props) => {

    const { onHide, setShowDeletedPlayerScoreMidClipPopupModal, showDeletedPlayerScoreMidClipPopupModal, data, deleteAction } = props;
    const [errorText, setErrorText] = useState(null);
    const [loader, showLoader, hideLoader] = UseFullPageLoaderHook();
    let errorLabel = errorText && errorText.length > 0 ? (
    <span className="text-danger">{errorText}</span>
    ) : (
    <></>
    );
    return(
        <div>
        <Modal
            show={showDeletedPlayerScoreMidClipPopupModal}
            onHide={onHide}
            backdrop="static"
            centered
        >
            <Modal.Header >
                <Modal.Title>
                    <h4 style={{ fontSize:"1.4rem"}}>
                        Are you sure you to want to delete action ? 
                    </h4>

                    <h6  style={{ fontSize:"0.9rem", color: "red" }}>
                        Deleting this action will also remove the mid clip ( supremacy: {data.currentSupremacy})
                    </h6> 
                    
                    <h6  style={{ fontSize:"0.9rem", color: "red" }}>
                        To keep mid-clip consider editing action
                    </h6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Row>
                    <Col>{errorLabel}</Col>
                </Row>
                <Button variant="success" onClick={async (e) => {
                    try {
                            showLoader();
                            onHide(e);
                            await deleteAction(data.type, data.id);
                            hideLoader();
                        }
                    catch (err) {
                            setShowDeletedPlayerScoreMidClipPopupModal(true);
                            hideLoader();
                            if (err && err.data && err.data.error) {
                                setErrorText(err.data.error);
                            } else {
                                setErrorText("An error occurred");
    
                        }
                    }
    
                }}>Confirm Delete</Button>
    
                <Button variant="danger" onClick={(e) => {
                    onHide(e);
                    setErrorText(null);
                }}>Cancel</Button>
            </Modal.Footer>
                </Modal>;
                {loader}
            </div>
        );
    }

export default DeletePlayerPopupModal; 